// SPDX-License-Identifier: MIT
// Pure relative-time humaniser for the sync badge. `now` is injectable for tests
// (Date.now() in prod). Returns '' for null/invalid so callers can omit the time.
import type { Locale } from '../i18n/detect';

export function timeAgo(iso: string | null | undefined, locale: Locale, now: number = Date.now()): string {
  if (!iso) return '';
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return '';
  const secs = Math.max(0, Math.floor((now - then) / 1000));
  const fr = locale === 'fr';
  if (secs < 60) return fr ? "à l'instant" : 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return fr ? `il y a ${mins} min` : `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return fr ? `il y a ${hours} h` : `${hours} h ago`;
  const days = Math.floor(hours / 24);
  return fr ? `il y a ${days} j` : `${days} d ago`;
}
